import dayjs from "dayjs";

export const parseDateOnlyForPicker = (dateString) => {
  if (!dateString) return null;
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return null;
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return dayjs(`${year}-${month}-${day}`);
};

export const toUTCMidnight = (date) => {
  const d = dayjs.isDayjs(date) ? date : dayjs(date);
  if (!d.isValid()) return null;
  return new Date(
    Date.UTC(d.year(), d.month(), d.date(), 0, 0, 0, 0)
  ).toISOString();
};

export const calculateDateFromLeadTime = (startDate, leadTimeWeeks) => {
  const d = dayjs.isDayjs(startDate) ? startDate : dayjs(startDate);
  const parsedLeadTime = Number.parseInt(leadTimeWeeks, 10);

  if (!d.isValid() || Number.isNaN(parsedLeadTime)) {
    return null;
  }

  return d.startOf("day").add(parsedLeadTime, "week");
};

export const calculateLeadTimeWeeks = (startDate, endDate) => {
  const start = dayjs.isDayjs(startDate) ? startDate : dayjs(startDate);
  const end = dayjs.isDayjs(endDate) ? endDate : dayjs(endDate);

  if (!start.isValid() || !end.isValid()) {
    return null;
  }

  const diffInDays = end.startOf("day").diff(start.startOf("day"), "day");
  return Number.isInteger(diffInDays / 7) ? diffInDays / 7 : null;
};

/**
 * Formats date-only fields (due_date, issue_date) in UTC.
 * Use for calendar dates stored as 00:00:00Z.
 */
export const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
};

/**
 * Formats event timestamps (created_at, completed_at, reviewed_on) in user's local timezone.
 * Use when the date represents "when did this happen" rather than a calendar deadline.
 */
export const formatDateLocal = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

/**
 * Formats date+time in user's local timezone (e.g. "February 18, 2026, 2:30 PM").
 * Use for timestamps like response dates, next run, updated at.
 */
export const formatDateTimeLocal = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
